import axios from 'axios';

export default {
    install: function(Vue, options) {
        Vue.prototype.$API = {
            uri: options.uri,

            getAll(){
                return axios
                .get(`${this.uri}/`)
                .then(response => { return response.data })
            },

            getLastData(skip=0, limit=0){
                return axios
                .get(`${this.uri}/last-data`, {
                    params: {skip, limit}
                })
                .then(response => { return response.data })
            },

            getId(id=''){
                return axios
                .get(`${this.uri}/_id/${id}`)
                .then(response => { return response.data })
            },

            getIP(ip=''){
                return axios
                .get(`${this.uri}/ip/${ip}`)
                .then(response => { return response.data })
            },

            getAllLoaders(){
                return axios
                .get(`${this.uri}/loaders`)
                .then(response => { return response.data })
            },

            getDomain(domain=''){
                return axios
                .get(`${this.uri}/domain/${domain}`)
                .then(response => { return response.data })
            },

            getFeeder(feeder=''){
                return axios
                .get(`${this.uri}/feeder/${feeder}`)
                .then(response => { return response.data })
            },

            getStatus(status=''){
                return axios
                .get(`${this.uri}/status/${status}`)
                .then(response => { return response.data })
            },

            getASOrg(asOrg=''){
                return axios
                .get(`${this.uri}/as_org/${asOrg}`)
                .then(response => { return response.data })
            },

            getASN(asn=''){
                return axios
                .get(`${this.uri}/asn/${asn}`)
                .then(response => { return response.data })
            },

            getCountryCode(countryCode=''){
                return axios
                .get(`${this.uri}/country_code/${countryCode}`)
                .then(response => { return response.data })
            },

            getPanelIndex(panelIndex=''){
                return axios
                .get(`${this.uri}/panel_index/${panelIndex}`)
                .then(response => { return response.data })
            },

            getPanelPath(panelPath=''){
                return axios
                .get(`${this.uri}/panel_path/${panelPath}`)
                .then(response => { return response.data })
            },

            getPanelVersion(panelVersion=''){
                return axios
                .get(`${this.uri}/panel_version/${panelVersion}`)
                .then(response => { return response.data })
            },

            getFirstSeen(firstSeen=''){
                return axios
                .get(`${this.uri}/first_seen/${firstSeen}`)
                .then(response => { return response.data })
            },

            /**
             * Get the number of infected computer per country.
             */
            getVictims(){
                return axios
                .get(`${this.uri}/victims`)
                .then(response => { return response.data })
            },

            /**
             * Get the number of panels discovered for each days.
             */
            getDiscovered(){
                return axios
                .get(`${this.uri}/discovered`)
                .then(response => { return response.data })
            },

            /**
             * Count of each value for a given field.
             */
            getListField(field){
                return axios
                .get(`${this.uri}/list/${field}`)
                .then(response => { return response.data })
            },

            /**
             * Number of distinct values for a given field.
             */
            getCountField(field){
                return axios
                .get(`${this.uri}/count/${field}`)
                .then(response => { return response.data })
            },
        }
    }
}
